<div class="sticky-top mat-elevation-z6">
    <mat-toolbar class="trip-header-bar bds-toolbar-blue">
        <mat-toolbar-row>
            <span>
                <fa-icon [icon]="iconTrain" [fixedWidth]="true" size="lg"></fa-icon>
                {{ ormIds.length }} <span>Interface Validation(s) Selected</span>
                <span *ngIf="isDirty">*</span>
                <span *ngIf="isSaving">
                    <small>
                        (saving...)
                        <fa-icon [icon]="iconSpinner" [spin]="true"></fa-icon>
                    </small>
                </span>
            </span>
            <span class="fill-remaining-space"></span>
            <span>
                <button
                    mat-stroked-button
                    (click)="addImports()"
                    [disabled]="isSaving || isChangesNotSaved"
                >
                    <fa-icon [icon]="import"></fa-icon> Add Imports
                </button>
                <button
                    mat-stroked-button
                    (click)="reProcess()"
                    [disabled]="isSaving || isChangesNotSaved"
                >
                    <fa-icon [icon]="reprocess"></fa-icon> Re Process
                </button>
                <button
                    mat-stroked-button
                    (click)="update()"
                    [disabled]="isSaving || !isChangesNotSaved"
                >
                    <fa-icon [icon]="save"></fa-icon> Update Interface Validations
                </button>
                <rt-trip-error-more-options
                    [trip]="selectedTripError"
                    [isMultiTripError]="true"
                ></rt-trip-error-more-options>
            </span>
        </mat-toolbar-row>
    </mat-toolbar>
    <div class="container-fluid jump-nav">
        <mat-chip-listbox>
            <mat-chip-option
                bdsScrollSpyLink="tripErrorGrid"
                color="accent"
                [selectable]="false"
                [highlighted]="(scrollSpyService.currentSection | async) === 'tripErrorGrid'"
                (click)="setCurrentSection('tripErrorGrid')"
            >
                <span>Interface Validations Grid</span>
            </mat-chip-option>
            <mat-chip-option
                bdsScrollSpyLink="tripErrorDetailsAnchor"
                color="accent"
                [selectable]="false"
                [highlighted]="
                    (scrollSpyService.currentSection | async) === 'tripErrorDetailsAnchor'
                "
                (click)="setCurrentSection('tripErrorDetailsAnchor')"
            >
                <span>Interface Detail</span>
            </mat-chip-option>
        </mat-chip-listbox>
    </div>
</div>
<mat-sidenav-container>
    <mat-sidenav
        mode="side"
        position="end"
        class="mat-elevation-z4 pt-3 side-nav"
        #tripSidenav
        [opened]="true"
    >
        <div class="side-nav-class" *ngFor="let trip of selectedTrips">
            <span (click)="showTrip(trip.id)">
                <ng-container [ngSwitch]="trip.state">
                    <fa-icon
                        [icon]="iconStatusSaved"
                        [fixedWidth]="true"
                        *ngSwitchCase="'saved'"
                        class="text-success"
                    ></fa-icon>
                    <fa-icon
                        [icon]="iconStatusSaving"
                        [fixedWidth]="true"
                        *ngSwitchCase="'saving'"
                        class="text-primary"
                        [spin]="true"
                    ></fa-icon>
                    <fa-icon
                        [icon]="iconStatusFailed"
                        [fixedWidth]="true"
                        *ngSwitchCase="'failed'"
                        class="text-danger"
                    ></fa-icon>
                    <fa-icon
                        [icon]="iconStatusNone"
                        [fixedWidth]="true"
                        *ngSwitchDefault
                        class="text-muted"
                        style="opacity: 0.1"
                    ></fa-icon>
                </ng-container>
                {{ trip.key.carInit }}{{ trip.key.carNo }}
            </span>
            <div *ngIf="trip.errors && trip.errors.length">
                <div class="error-warning" *ngFor="let error of trip.errors">
                    {{ error.errorMessage }}
                </div>
            </div>
        </div>
    </mat-sidenav>
    <div class="pt-3">
        <!-- Trip Details-->
        <div bdsScrollSpySection="tripErrorGrid" [scrollMargin]="116" #tripErrorGrid>
            @if (loading) {
            <div>Loading...</div>
            } @else {
            <rt-trip-error-details
                #tripErrorDetails
                [tripError]="selectedTripError"
                [tripErrorOrmIds]="ormIds"
                [highlightDirty]="true"
                (notifyToUpdateTrip)="reProcess()"
                [allowPopout]="allowPopout"
                [multipleTrips]="true"
                (formDirtyChange)="onFormDirtyChange($event)"
            >
            </rt-trip-error-details>
            }
        </div>
    </div>
</mat-sidenav-container>

<div style="padding-bottom: 500px"></div>
